<template>
    <div class="animated fadeIn">
     
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
                <b-row>
                    <b-col>
                        <strong> EBN Extension </strong>
                    </b-col>
                    <b-col>
                        <strong style="float: right;"> Date : {{date}} </strong> 
                    </b-col>
                </b-row>
                

            </div>
            <b-row>
             <b-col md="12" >
      
             <div>
              <ul class="nav nav-tabs nav-justified">
                <li class="nav-item">
                    <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">EBN Expiring Today</a>
                </li>

                <li class="nav-item">
                    <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >EBN Extended Today</a>
                </li> 
                <li class="nav-item">
                    <a @click="activeTab = 2"  class="nav-link" :class="{'active' : isActiveTab(2)}" >EBN Expired</a>
                </li> 
                <li class="nav-item">
                  <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" >Extend EBN Validity</a>
                </li> 
              </ul>
            </div>
             
            </b-col>
            <b-col md="12" >
          
              <div class="tab-panel" v-if="isActiveTab(0)">
                <ENB_Expiring></ENB_Expiring>
              </div>

              <div class="tab-panel" v-if="isActiveTab(1)">
              <ENB_Extended></ENB_Extended>
              </div>
              <div class="tab-panel" v-if="isActiveTab(2)">
                  <ENB_Expiring_all></ENB_Expiring_all>
              </div>
              <div class="tab-panel" v-if="isActiveTab(3)">
                <ENB_Extend_Validity></ENB_Extend_Validity>
              </div>
             </b-col>
            </b-row> 
          </b-card>
         
        </b-col>
      </b-row> 
    </div>   
  </template>
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import ENB_Expiring from './ENB_expiring.vue'
  import ENB_Extended from './ENB_extended.vue'
  import ENB_Expiring_all from './ENB_Expiring_all.vue'
  import ENB_Extend_Validity from './ENB_extend_validity.vue'
  export default {
    data: function() {
      return {
        activeTab: 0,
        ENB_Expiring,
        ENB_Extended,
        ENB_Expiring_all,
        ENB_Extend_Validity,
        date :'',
      };
    },
    components: {
        ENB_Expiring,
        ENB_Extended,
        ENB_Expiring_all,
        ENB_Extend_Validity,
    },
    created: function() {
      this.isActiveTab(0);
      this.todaydate();
    },
    methods: {
        isActiveTab(id)
        {
            return this.activeTab === id
        },

        todaydate (){
            var today = new Date();
            // Current Date
            this.date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

            console.log("date",this.date)

        },
    }
  };
  </script>
